import create from '@verndale/core'
import modules, { global } from './modules'
import { setViewportHeight } from './utils'

let modulesCreated = false

document.addEventListener('DOMContentLoaded', () => {
  if (modulesCreated) return
  modulesCreated = true
  setViewportHeight()

  global()
  create(modules)
})

window.onload = function() {
  var link = window.location.href;
  if(link.includes('#')){
    document.getElementById(link.split('#')[1]).scrollIntoView();
    window.scrollBy(0, -50);
  }
  var headerSticky = document.querySelectorAll('.header__sticky');
  if(headerSticky.length >0){
    var jumpLinksContainer = document.querySelectorAll('.jump-links__container');
    if(jumpLinksContainer.length > 0){
      jumpLinksContainer[0].classList.add('jump-links__sticky');
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const formSelector = '.sitecore-form.block';
  let captchaPassed = false,
    captchaRequired = false;

  function scrollToForm() {
    const formElement = document.querySelector(formSelector);
    if (formElement) {
      const yOffset = window.innerWidth < 768 ? -60 : -120;
      const yPosition = formElement.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: yPosition, behavior: 'smooth' });
    }
  }

  function checkFormSubmission() {
    setTimeout(() => {
      const validationErrors = document.querySelectorAll('.field-validation-error');
      const hasCaptchaError = [...validationErrors].some((err) => err.textContent.includes('Captcha'));
      const hasOtherErrors = validationErrors.length > 0 && !hasCaptchaError;

      if (hasCaptchaError) {
        captchaRequired = true;
        captchaPassed = false;
      } else {
        if (!captchaRequired || captchaPassed) {

          scrollToForm();
        }
      }
    }, 2000);
  }

  window.onRecaptchaSuccess = function() {
    captchaPassed = true;
    captchaRequired = false;
  };

  document.addEventListener('submit', (event) => {
    if (event.target.closest(formSelector)) {
      checkFormSubmission();
    }
  });
});
